import { Logo2n } from '@2n/design-system';
import { Box, Link, Stack, Typography } from '@mui/material';
import { LoginContainer } from '@my2n/login-container';
import * as React from 'react';
import loginBg from '../../../assets/login.jpg';
import CookieSettingsButton from '../../../components/CookieSettingsButton';
import { PATHS } from '../../../config/consts';
import actions from '../../../modules/localization';
import { loginPageLanguageItems } from '../../../modules/localization/helpers';
import messages from './messages';
import { useLoginFlowsWrapper } from './useLoginFlowsWrapper';

interface ILoginFlowsWrapper {
  title: React.ReactNode | string;
  subTitle?: React.ReactNode | string;
  children: React.ReactNode;
}

export function LoginFlowsWrapper({ children, subTitle, title }: ILoginFlowsWrapper) {
  const { currentUserLang, dispatch, formatMessage, link2N, yearTo } = useLoginFlowsWrapper();

  return (
    <LoginContainer
      cookieSettingsContent={<CookieSettingsButton iconColor="grey.300" />}
      customLogo={
        <Link
          data-testid="my2n-logo-link"
          href={PATHS.HOMEPAGE}
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Logo2n width="39px" />
        </Link>
      }
      inverted
      copyrightText={formatMessage(messages.footerPublicCopyright, { yearTo })}
      rightContent={{
        link: {
          label: formatMessage(messages.marketingMessageButtonLabel),
          url: link2N,
        },
        logo: { hasOverlay: true, position: '90% 50%', url: loginBg },
        subtitle: formatMessage(messages.marketingMessageSubtitle),
        title: formatMessage(messages.marketingMessageTitle),
      }}
      productName="My2N"
      languageSwitch={{
        ariaLabel: 'Select Language',
        items: loginPageLanguageItems,
        onChange(item) {
          dispatch(actions.setLandingPageLanguage(item.value!, false));
        },
        value: currentUserLang,
      }}
    >
      <Stack spacing={4} sx={{ maxWidth: '620px', px: 1.25, width: '100%' }}>
        <Box>
          <Typography sx={{ color: 'chip.text', fontWeight: '500', mb: 1, textAlign: 'left' }} variant="h4">
            {title}
          </Typography>
          {!!subTitle && subTitle}
        </Box>
        <Box>{children}</Box>
      </Stack>
    </LoginContainer>
  );
}
